export const version = "logger/5.4.0";
//# sourceMappingURL=_version.js.map